export const truncateAssetName = (name: string, maxLength: number): string => {
  if (name.length <= maxLength) return name;

  const endLength = Math.floor(maxLength / 3);

  const startLength = maxLength - endLength;

  return `${name.substring(0, startLength)} ... ${name.substring(name.length - endLength)}`;
};
